/* eslint-disable @typescript-eslint/no-deprecated */

import React from 'react'
import styled from 'styled-components'
import { Caption } from '../../../../styles'
import { ArrowIcon } from '../images/MenuArrow'

interface Props {
  active: boolean
  toggleActive: () => void
  title: string
}

export const FilterMenu: React.FC<React.PropsWithChildren<Props>> = ({ active, toggleActive, title, children }) => {
  const contentId = `filtermenu-${title.replace(/\s/g, '')}`
  return (
    <>
      <Container aria-controls={contentId} aria-expanded={active ? 'true' : 'false'} onClick={() => toggleActive()}>
        <Caption>{title}</Caption>
        <Arrow active={active} />
      </Container>
      <Border />
      <div aria-hidden={!active} id={contentId}>
        {active && <FilterMenuItems>{children}</FilterMenuItems>}
      </div>
    </>
  )
}

const Container = styled.button`
  border: 0;
  background-color: transparent;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 2rem 1rem;
  user-select: none;
  margin-top: 1rem;
`

const FilterMenuItems = styled.div`
  display: flex;
  flex-direction: column;
`

const Border = styled.div`
  border-bottom: 0.2rem solid ${({ theme }) => theme.colors.grey.light};
`

const Arrow = styled(ArrowIcon)<{ active: boolean }>`
  transform: ${(p) => !p.active && 'rotate(180deg)'};
  width: 1.5rem;
  fill: ${({ theme }) => theme.colors.dark};
  height: 1.5rem;
`
